import React from 'react';
import {
  CardBody,
  CardBodyTitle,
  CardBodyContainer,
  CardBodyBtn,
  CardBodyCourse,
  CardBodyParahraph,
  CardBodyImg
} from './styles';
import TextHelper from '../../../../../core/helpers/TextHelper';
import DateHelpers from '../../../../../core/helpers/DateHelper';
import CardHelpers from '../../../../../core/helpers/CardHelper';
import {
  cardIcon,
  cardLocation
} from '../../../../components/Schedule/components/CardCourse';
import { Icon } from '../../../../components';

interface Props {
  title: string;
  startTime: number;
  endTime: number;
  type: string;
  location: string;
  isReprog: boolean;
  isCruce: boolean;
  handlerRedirectPage: any;
  numero: any;
  instructionMode: any;
}

const CardSchedule = (props: Props) => {
  const {
    title,
    startTime,
    endTime,
    type,
    location,
    isReprog,
    handlerRedirectPage,
    isCruce,
    numero,
    instructionMode
  } = props;
  const colorTag = CardHelpers.getCardTagColor(type);
  const backgroundTag = CardHelpers.getCardTagBackgroundColor(type);
  let classStyle = '';

  const getClassName = (cruce: any, reprog: any) => {
    if (cruce) {
      classStyle += ' line';
    }

    if (reprog) {
      classStyle += ' repro';
    }
    return classStyle;
  };

  const evalTitle = () => {
    if (['E', 'A', 'R'].includes(type))
      return `Evaluación: ${TextHelper.capitalize(title)}`;
    if (['C', 'V', 'P'].includes(type))
      return `Curso : ${TextHelper.capitalize(title)}`;
    return TextHelper.capitalize(title);
  };
  const evalTextColor = () => {
    if (['E', 'A', 'R'].includes(type)) return '#161d1f';
    if (['C', 'V', 'P'].includes(type)) return '#ffffff';
    return '#fff';
  };

  return (
    <CardBody
      type="button"
      className={getClassName(isCruce, isReprog)}
      isCruce={isCruce}
      isReprog={isReprog}
      cardType={type}
      styleType={classStyle.trim()}
      onClick={() => handlerRedirectPage('/calendario')}
    >
      {!['E', 'A', 'R'].includes(type) && (
        <CardBodyBtn color={colorTag} background={backgroundTag}>
          {' '}
          {CardHelpers.getCardTagLabel(type)}{' '}
        </CardBodyBtn>
      )}
      <CardBodyTitle style={{ color: evalTextColor() }}>
        {' '}
        {evalTitle()}
      </CardBodyTitle>

      <div className="container__hora--cruce">
        <span style={{ color: evalTextColor() }}>
          {DateHelpers.formatHour(startTime)} -{' '}
          {DateHelpers.formatHour(endTime)}{' '}
        </span>

        {isCruce && numero === 1 && (
          <div className="icon__cruce">
            <Icon name="alert-triangle" size={20} color={evalTextColor()} />
            <h1 style={{ color: evalTextColor() }}>Cruce</h1>
          </div>
        )}

        {isReprog && (
          <div className="icon__repro">
            <Icon name="alert-circle" size={20} color={evalTextColor()} />
            {/* <img
              className="icon__cruce__repro"
              src={IconReproCircle}
              alt="IconReproCircle"
            /> */}
            <h1 style={{ color: evalTextColor() }}>Reprogramación</h1>
          </div>
        )}
      </div>
      <CardBodyContainer>
        <CardBodyCourse>
          <CardBodyImg src={cardIcon(type, instructionMode)} />
          <CardBodyParahraph style={{ color: evalTextColor() }}>
            {' '}
            {cardLocation(type, location, instructionMode)}{' '}
          </CardBodyParahraph>
        </CardBodyCourse>
      </CardBodyContainer>
    </CardBody>
  );
};

export default CardSchedule;
